export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^[+]?[\d\s\-()]+$/;
  return phoneRegex.test(phone);
};

export const validateUrl = (url: string): boolean => {
  try {
    new URL(url.startsWith('http') ? url : `https://${url}`);
    return true;
  } catch {
    return false;
  }
};

export const styles = {
  noFocusAnimation: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: 'transparent' },
      '&:hover fieldset': { borderColor: 'transparent' },
      '&.Mui-focused fieldset': { borderColor: 'transparent' },
    },
    '& .MuiInputBase-input': { cursor: 'default' },
  },
  card: {
    borderRadius: 2,
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    border: '1px solid',
    borderColor: 'divider',
  },
  cardTitleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 2.5,
    py: 1.25,
  },
  cardContent: { px: 2.5, pt: 0.75, pb: 2, flexGrow: 1 },
  label: {
    fontSize: '0.775rem',
    color: 'text.secondary',
    mb: 0.5,
    fontWeight: 500,
  },
  value: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: 'text.primary',
  },
};
